export GalleryTab from './GalleryTab';
export MetadataTab from './MetadataTab';
export TextsTab from './TextsTab';



// WEBPACK FOOTER //
// ./src/frontend/modules/content/property-content/components/index.js